import React from 'react';
import screenshot from '../assets/screenshot.jpg';
import surfSvg from '../assets/surf.svg';
import shareSvg from '../assets/share.svg';
import bookmarkSvg from '../assets/bookmark-white.svg';

function About() {
    return (
        <div className="bg-white">
            {/* Why Section */}
            <section className="py-20 px-4 sm:px-6 lg:px-8" id="about">
                <div className="max-w-7xl mx-auto">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                        <div className="order-2 lg:order-1">
                            <img
                                src={screenshot}
                                alt="Axomark Screenshot"
                                className="rounded-2xl shadow-2xl w-full"
                            />
                        </div>
                        <div className="order-1 lg:order-2">
                            <h2 className="text-4xl font-bold text-gray-900 mb-6">
                                Why Axomark?
                            </h2>
                            <p className="text-lg text-gray-600 leading-relaxed">
                                Axomark is not only for private bookmarks. Where it shines is in collaboration - think of it like Pocket / Instapaper but with the ability to share your collection of bookmarks with password protection for individual collections.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Use Cases Section */}
            <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-gray-50 to-white">
                <div className="max-w-7xl mx-auto text-center">
                    <h2 className="text-4xl font-bold text-gray-900 mb-4">
                        For any use case, especially...
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full mb-16"></div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Teams</h3>
                            <p className="text-gray-600">
                                Use it as a Google Docs for bookmarks. Place your shared resources on Axomark for a password-protected list.
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Courses</h3>
                            <p className="text-gray-600">
                                Place course resources on Axomark and share a read-only link to students. The resource list will be updated every time items are added / deleted!
                            </p>
                        </div>

                        <div className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow">
                            <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-pink-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                                </svg>
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Curated "awesome" lists</h3>
                            <p className="text-gray-600">
                                Instead of a GitHub "awesome" repo (or nested "awesome" repos), you can have an Axomark collection. No git / markdown knowledge required.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-gray-900 mb-4">Features</h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                        <div className="text-center">
                            <div className="w-24 h-24 mx-auto mb-6 p-6 bg-blue-50 rounded-2xl">
                                <img src={surfSvg} alt="No account required" className="w-full h-full" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">No account required</h3>
                            <p className="text-gray-600">
                                Axomark doesn't require an account to start with. Simply create a collection, save your password, and start for free.
                            </p>
                        </div>

                        <div className="text-center">
                            <div className="w-24 h-24 mx-auto mb-6 p-6 bg-purple-50 rounded-2xl">
                                <img src={shareSvg} alt="Sharable collection" className="w-full h-full" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Sharable collection</h3>
                            <p className="text-gray-600">
                                You can share an individual collection, or{' '}
                                <a href="/robookmarks/discover" className="text-blue-600 hover:text-blue-700 font-medium underline">
                                    a collection of collections
                                </a>
                                . Shared collections update automatically when new bookmarks are added.
                            </p>
                        </div>

                        <div className="text-center">
                            <div className="w-24 h-24 mx-auto mb-6 p-6 bg-pink-50 rounded-2xl">
                                <img src={bookmarkSvg} alt="Bookmarks only" className="w-full h-full" />
                            </div>
                            <h3 className="text-2xl font-bold text-gray-900 mb-4">Bookmarks only</h3>
                            <p className="text-gray-600">
                                Axomark provides a simple, intuitive interface for adding, editing, and sharing bookmarks. It is a bookmarks-only service and doesn't intend to be anything else.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* How to Use Section */}
            <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50" id="howto">
                <div className="max-w-4xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-4xl font-bold text-gray-900 mb-4">How to use</h2>
                        <div className="w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 mx-auto rounded-full"></div>
                    </div>

                    <div className="space-y-12">
                        <div className="bg-white p-8 rounded-2xl shadow-sm">
                            <h3 className="text-2xl font-bold text-gray-900 mb-6">Adding bookmarks</h3>
                            <ol className="space-y-4 text-gray-600">
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">1</span>
                                    <span className="pt-1">
                                        Click the "Create Collection" button at the top-right of the{' '}
                                        <a href="/" className="text-blue-600 hover:text-blue-700 font-medium underline">home page</a>
                                    </span>
                                </li>
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">2</span>
                                    <span className="pt-1">Add your title and optionally a password. Without password, anyone who knows the url of the collection will be able to edit your collection</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">3</span>
                                    <span className="pt-1">Click the "+" button in your collection to add a bookmark title and a valid url</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-blue-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">4</span>
                                    <span className="pt-1">Save the collection's url for future access</span>
                                </li>
                            </ol>
                        </div>

                        <div className="bg-white p-8 rounded-2xl shadow-sm">
                            <h3 className="text-2xl font-bold text-gray-900 mb-6">Sharing bookmarks</h3>
                            <ol className="space-y-4 text-gray-600">
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">1</span>
                                    <span className="pt-1">Clicking on the "Share" button will show two options</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">2</span>
                                    <span className="pt-1">The readonly link is disabled by default. It can be accessed by anyone without a password</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">3</span>
                                    <span className="pt-1">The editable link can only be accessed with a password</span>
                                </li>
                                <li className="flex items-start">
                                    <span className="flex-shrink-0 w-8 h-8 bg-purple-500 text-white rounded-full flex items-center justify-center font-semibold mr-4">4</span>
                                    <span className="pt-1">Alternatively, export the current collection to Markdown or Html format, and share the exported file</span>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer CTA */}
            <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-blue-600 to-purple-600">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
                        Ready to get started?
                    </h2>
                    <p className="text-xl text-blue-100 mb-8">
                        Create your first collection in seconds. No sign-up required.
                    </p>
                    <a
                        href="/"
                        className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-blue-600 bg-white rounded-xl hover:bg-gray-50 transition-colors shadow-lg hover:shadow-xl"
                    >
                        Get Started
                        <svg className="ml-2 w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
                        </svg>
                    </a>
                </div>
            </section>
        </div>
    );
}

export default About;
